<template>
    <div>
        <domain-meta :domain="domain" :subscription="subscription" />

        <cancel-subscriptions :subscription="subscription" :domain="domain" />

        <domain-whois
            v-if="whoisData"
            :whoisData="whoisData"
            :domain="subscription.domain"
            :subscription="subscription"
        />

        <domain-dns
            :domain="domain"
            :nameservers="nameservers"
            :nameservergroup="nameservergroup"
            :dnssecKeys="dnssecKeys"
        />
    </div>
</template>

<script>
import DomainMeta from './DomainMeta.vue';
import DomainDns from './DomainDns.vue';
import DomainWhois from './DomainWhois.vue';
import { CancelSubscriptions } from 'relapp-technical-management';
import { productsMixin } from 'relapp-register';

export default {
    components: {
        DomainMeta,
        DomainDns,
        DomainWhois,
        CancelSubscriptions
    },
    mixins: [productsMixin],
    props: {
        domain: {
            type: String,
            required: true
        },
        subscription: {
            type: Object,
            required: true
        },
        nameservers: {
            type: Array,
            default: null
        },
        nameservergroup: {
            type: String,
            default: null
        },
        whoisData: {
            type: Object,
            default: null
        },
        dnssecKeys: {
            type: Array,
            default: () => []
        }
    }
};
</script>
